export default [
  {
    path: "/admin/usuarios/",
    name: "UsersList",
    meta: { adminOnly: true },
    component: () =>
      import(/* webpackChunkName: "users-list" */ "../views/admin/users/List"),
  },
  {
    path: "/admin/usuarios/crear",
    name: "UsersCreate",
    meta: { adminOnly: true },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/admin/users/Create"),
  },
  {
    path: "/admin/usuarios/:id/editar",
    name: "UsersEdit",
    meta: { adminOnly: true },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/admin/users/Edit.vue"),
  },
  {
    path: "/admin/usuarios/:id/contraseña",
    name: "UsersChangePassword",
    meta: { adminOnly: true },
    component: () =>
      import(
        /* webpackChunkName: "users-change-password" */ "../views/admin/users/ChangePassword.vue"
      ),
  },
];
